<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
// import { useCssVar, useResizeObserver, useScroll } from "@vueuse/core";
import { onMounted, ref } from "vue";

import { gsap } from "@/vendor/gsap";
import { ScrollTrigger } from "@/vendor/gsap/ScrollTrigger";
import { SplitText } from "@/vendor/gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

const el = ref(null);

onMounted(() => {
    const section = el.value.closest("section");
    const trigger = section.querySelector(".section-sticky-text__content");
    const color = section.classList.contains("foreground-light")
        ? "#ffffff"
        : "#090d17";

    const split = new SplitText(el.value.querySelector("p"), {
        type: "chars, words",
    });

    ScrollTrigger.matchMedia({
        "(min-width:768px)": function () {
            gsap.timeline({
                scrollTrigger: {
                    trigger: trigger,
                    start: "center 50%",
                    end: "+=80%",
                    pin: true,
                    scrub: 0.75,
                    markers: false,
                },
            }).set(
                split.chars,
                {
                    color,
                    stagger: 0.1,
                },
                0.1
            );
        },
        "(max-width:767px)": function () {
            gsap.timeline({
                scrollTrigger: {
                    trigger: trigger,
                    start: "top top",
                    end: "+=80%",
                    pin: true,
                    scrub: 0.75,
                    markers: false,
                },
            }).set(
                split.chars,
                {
                    color,
                    stagger: 0.1,
                },
                0.1
            );
        },
    });
});
</script>

<template>
    <div class="sticky-text" ref="el">
        <slot />
    </div>
</template>

<style lang="scss">
</style>
